
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Mantida a formatação original da data em UTC
const formatarData = (data) => {
  const date = new Date(data);

  const dia = String(date.getUTCDate()).padStart(2, "0");
  const mes = String(date.getUTCMonth() + 1).padStart(2, "0");
  const ano = date.getUTCFullYear();

  return `${dia}/${mes}/${ano}`;
};

const FolgasList = () => {
  const [folgas, setFolgas] = useState([]);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);
  const navigate = useNavigate();

  const fetchFolgas = async () => {
    try {
      setCarregando(true);

      await axios.get(
        "https://acesso.cronosagenda.com.br/api/verificar-autenticacao",
        { withCredentials: true }
      );

      const response = await axios.get(
        "https://acesso.cronosagenda.com.br/api/folgas",
        { withCredentials: true }
      );

      setFolgas(response.data);
    } catch (err) {
      setErro("Erro ao buscar folgas. Redirecionando para o login...");
      console.error("Erro ao buscar folgas:", err);
      navigate("/login");
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    fetchFolgas();
  }, [navigate]);

  const handleExcluirFolga = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir esta folga?")) {
      return;
    }

    try {
      await axios.delete(
        `https://acesso.cronosagenda.com.br/api/folgas/${id}`,
        { withCredentials: true }
      );

      setFolgas(folgas.filter((folga) => folga.id !== id));
      setErro("");
    } catch (err) {
      setErro("Erro ao excluir a folga.");
      console.error(err);
    }
  };

  const getTipoFolgaTexto = (folga) => {
    if (folga.tipo === "todos") {
      return "Todos os funcionários";
    } else if (folga.tipo === "especifico" && folga.funcionario_nome) {
      return `Apenas ${folga.funcionario_nome}`;
    } else {
      return "Funcionário específico";
    }
  };

  const getCorTipoFolga = (tipo) => {
    return tipo === "todos" ? "#2e7d32" : "#d32f2f";
  };

  if (carregando) {
    return (
      <div className="folgas-list">
        <div className="folgas-list__loading">
          <span className="folgas-list__spinner" />
          <p>Carregando folgas...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="folgas-list">
      {erro && (
        <div className="folgas-list__error" role="alert">
          <span>{erro}</span>
        </div>
      )}

      {folgas.length === 0 ? (
        <div className="folgas-list__empty">
          <div className="folgas-list__empty-icon" aria-hidden="true">
            <span>▦</span>
          </div>

          <h3>Nenhuma folga cadastrada</h3>

          <p>
            As folgas cadastradas aparecerão aqui para facilitar a consulta.
          </p>
        </div>
      ) : (
        <div className="folgas-list__container">
          <div className="folgas-list__summary">
            <span className="folgas-list__summary-label">
              Folgas cadastradas
            </span>

            <span className="folgas-list__count">
              {folgas.length}
            </span>
          </div>

          <div className="folgas-list__scroll">
            <table className="folgas-list__table">
              <thead>
                <tr>
                  <th className="folgas-list__date-column">Data</th>
                  <th className="folgas-list__type-column">Tipo</th>
                  <th className="folgas-list__employee-column">
                    Funcionário
                  </th>
                  <th className="folgas-list__actions-column">Ações</th>
                </tr>
              </thead>

              <tbody>
                {folgas.map((folga) => (
                  <tr key={folga.id}>
                    <td className="folgas-list__date">
                      <span>{formatarData(folga.data)}</span>
                    </td>

                    <td>
                      <span
                        className={`folgas-list__badge ${
                          folga.tipo === "todos"
                            ? "folgas-list__badge--general"
                            : "folgas-list__badge--specific"
                        }`}
                      >
                        {folga.tipo === "todos" ? "GERAL" : "ESPECÍFICA"}
                      </span>
                    </td>

                    <td>
                      <div
                        className="folgas-list__employee"
                        title={folga.funcionario_nome || "-"}
                      >
                        {folga.funcionario_nome || "-"}
                      </div>
                    </td>

                    <td className="folgas-list__action-cell">
                      <button
                        type="button"
                        onClick={() => handleExcluirFolga(folga.id)}
                        className="folgas-list__delete-button"
                        title="Excluir folga"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M4 7h16M10 11v6m4-6v6M5 7l1 14h12l1-14M9 7V4h6v3"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <span>Excluir</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default FolgasList;
